import { Nomenclature as OrderNomenclature } from '../../orders/model'
import { Nomenclature } from '../../nomenclatures/model'
import { AutocompleteOption } from 'shared/components/Autocomplete'

export type NomenclaturesOptions = AutocompleteOption<{ type: number }>
export const adaptNomenclaturesToOption = (
    nomenclature: OrderNomenclature | Nomenclature,
): NomenclaturesOptions => ({
    value: nomenclature.id.toString(),
    label: nomenclature.name,
    payload: {
        type: nomenclature.type,
    }
})
